import { render, staticRenderFns } from "./sexPicker.vue?vue&type=template&id=b01bd30e"
import script from "./sexPicker.vue?vue&type=script&lang=js"
export * from "./sexPicker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports